<template>
  <div class="btn-create">
    <Dropdown :hideArrow="true" ref="moreActionCreate" lclass="btn-create-dropdown" bclass="btn btn-primary">
      <template v-slot:button>
        <svg class="mr-1" width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="4.25024" width="1.5" height="10" rx="0.75" fill="#E2E2E2" />
          <rect y="5.74994" width="1.5" height="10" rx="0.75" transform="rotate(-90 0 5.74994)" fill="#E2E2E2" />
        </svg>
        {{ $t("group.addPage") }}
      </template>
      <div class="gp_dropdown-item btn-create-item" @click="itemCreateClick(addPages)">
        <div class="text-content text-left">
          <h2 class="typo-heading16 typo-medium text-light-high mb-1">{{ $t("page.btnCreate.fromPages") }}</h2>
          <p class="typo-paragraph12 typo-regular-150 text-light-low">{{ $t("page.btnCreate.fromPagesDesc") }}</p>
        </div>
      </div>
      <div class="gp_dropdown-item btn-create-item" @click="itemCreateClick(templatePage)">
        <div class="text-content text-left">
          <h2 class="typo-heading16 typo-medium text-light-high mb-1">{{ $t("page.btnCreate.newPage") }}</h2>
          <p class="typo-paragraph12 typo-regular-150 text-light-low">{{ $t("page.btnCreate.newPageDesc") }}</p>
        </div>
      </div>
    </Dropdown>
  </div>
</template>

<script>
export default {
  name: "ButtonAddPages",
  props: {},
  data() {
    return {};
  },
  computed: {},
  methods: {
    itemCreateClick(fn) {
      if (this.$refs.moreActionCreate) {
        this.$refs.moreActionCreate.toggleDropdown();
      }
      if (fn) fn();
    },
    templatePage() {
      this.$emit("onClickTemplatePage");
    },
    addPages() {
      this.$emit("onClickAddPages");
    }
  }
};
</script>

<style lang="scss" scoped>
.btn-create {
  @include trans-all;
  display: inline-flex;
  ::v-deep .btn-create-dropdown {
    width: 280px;
    right: 0;
    border: none;

    .btn-create-item {
      padding: 16px 24px;
      display: flex;
      border: none !important;

      &:hover {
        @include trans-all;
        svg {
          fill: $cPrimary;
        }
        .text-content {
          p:last-child {
            color: $black1;
          }
        }
      }

      .text-content {
        flex: 1;
        p:not(:last-child) {
          margin-bottom: 4px;
        }
      }
    }
  }
}
</style>
